// extracted by mini-css-extract-plugin
export var chevron = "_k0-2";
export var dropdownItems = "_k0-0";
export var item = "_k0-1";